__turbopack_context__.v({
  "base": "button-module-scss-module__mTv01W__base",
  "disabled": "button-module-scss-module__mTv01W__disabled",
  "loading": "button-module-scss-module__mTv01W__loading",
  "primary": "button-module-scss-module__mTv01W__primary",
  "secondary": "button-module-scss-module__mTv01W__secondary",
});
